import { __decorate, __metadata, __param } from "tslib";
import { buildFormDate } from '@/@core/utils/form';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { get, compact, sortBy, findIndex } from 'lodash';
import { format } from '@/@core/utils/string';
// 角色排序列表
const rolesSortList = [
    {
        id: 'backoffice-developer_admin',
    }, {
        id: 'id_backoffice_admin',
    }, {
        id: 'internal_user_administrator',
    }, {
        id: 'id_backoffice_pm',
    }, {
        id: 'id_backoffice_cs',
    }, {
        id: 'id_backoffice_am_ka',
    }, {
        id: 'id_backoffice_sales',
    }, {
        id: 'id_backoffice_bo_developer',
    }, {
        id: 'id_backoffice_developer',
    }, {
        id: 'maintain_trial_permission',
    }, {
        id: 'id_backoffice_only_view_own_customer',
    }, {
        id: 'edit_org_security_setting',
    }, {
        id: 'account_management_security',
    }, {
        id: 'operation_manager',
    }, {
        id: 'data_protection',
    }, {
        id: 'system_limit',
    }, {
        id: 'tfft_cache_management',
    }, {
        id: 'id_backoffice_maintain_contact',
    }, {
        id: 'id_backoffice_maintain_commercial_order',
    }, {
        id: 'id_backoffice_maintain_cooperative_order',
    }, {
        id: 'id_backoffice_maintain_internal_order',
    }, {
        id: 'backoffice_resource_allocator',
    }, {
        id: 'backoffice_resource_viewer',
    }
];
// 非独权角色列表
export const MainRolesList = [
    {
        id: 'backoffice-developer_admin',
    }, {
        id: 'id_backoffice_admin',
    }, {
        id: 'internal_user_administrator',
    }, {
        id: 'id_backoffice_pm',
    }, {
        id: 'id_backoffice_cs',
    }, {
        id: 'id_backoffice_am_ka',
    }, {
        id: 'id_backoffice_sales',
    }, {
        id: 'id_backoffice_bo_developer',
    }, {
        id: 'id_backoffice_developer',
    }, {
        id: 'backoffice_resource_viewer',
    }
];
let ProductsService = class ProductsService {
    constructor(productApi, http, urls, productService) {
        this.productApi = productApi;
        this.http = http;
        this.urls = urls;
        this.productService = productService;
    }
    // 获取资源详情
    async getResource(resource_id) {
        return await this.productApi.getResource(resource_id);
    }
    // 删除资源详情
    async deleteResource(resource_ids) {
        return await this.productApi.deleteResource(resource_ids);
    }
    // 修改 / 新增资源
    async postResource(params) {
        return await this.productApi.postResource(params);
    }
    // 获取资源国际化
    async getResourceLan(resource_id) {
        return await this.productApi.getResourceLan(resource_id);
    }
    // 修改资源国际化
    async postResourceLan(resource_id, params) {
        return await this.productApi.postResourceLan(resource_id, params);
    }
    // 获取 资源 API 数据
    async getResourceApi(resource_id) {
        return await this.productApi.getResourceApi(resource_id);
    }
    // 删除 资源 API
    async deleteResourceApi(resource_id) {
        return await this.productApi.deleteResourceApi(resource_id);
    }
    // 修改 资源 API
    async postResourceApi(params) {
        return await this.productApi.postResourceApi(params);
    }
    // 获取 产品 - 角色  如果是backoffice 的话,这里要进行排序
    async getProductRoles(product_id) {
        let roleList = await this.productApi.getProductRoles(product_id);
        if (product_id === 'backoffice') {
            roleList = sortBy(roleList, item => {
                const index = findIndex(rolesSortList, { id: item.id });
                return index === -1 ? rolesSortList.length : index;
            });
            return compact(roleList);
        }
        return roleList;
    }
    // 获取 产品 - 所有角色 - 资源
    async getProductResource(product_id) {
        return await this.productApi.getProductResource(product_id);
    }
    // 获取 产品 - 所有角色 - 模块下的 - 资源
    async getProductResourceByModule(product_id, module_type) {
        return await this.productApi.getProductResourceByModule(product_id, module_type);
    }
    // 获取 产品 - 所有角色 - 数据资源
    async getProductDataResource(product_id) {
        return await this.productApi.getProductDataResource(product_id);
    }
    // 获取 产品 - 当前角色 - 角色资源的选中状态
    async getResourceByRole(role_id) {
        const url = format(this.urls.getResourceByRole, { role_id });
        return await this.http.get({
            url,
        });
    }
    // 获取 产品 - 当前角色 - 角色数据资源的选中状态
    async getDataResourceByRole(role_id) {
        const url = format(this.urls.getDataResourceByRole, { role_id });
        return this.http.get({
            url,
        });
    }
    // 产品相关
    async getProducts() {
        const products = await this.productService.getAllProductionProducts();
        return products;
    }
    /** 产品角色导入 */
    postRoleResource(params) {
        const url = this.urls.postRoleResource;
        return this.http.post({
            url,
            data: buildFormDate(params),
        });
    }
    /* 批量修改角色资源 */
    async postBatchRoleResource(params) {
        const resourceParams = params.resource;
        const dataResourceParams = params.dataResource;
        const result = { resource: null, dataResource: null };
        if (get(resourceParams, 'roles_resources_pojo.length', 0)) {
            const url = this.urls.postBatchRoleResource;
            result.resource = await this.http.post({
                url,
                data: resourceParams,
            });
        }
        if (get(dataResourceParams, 'roles_resources_pojo.length', 0)) {
            const url = this.urls.postBatchRoleDataResource;
            result.dataResource = await this.http.post({
                url,
                data: dataResourceParams,
            });
        }
        return result;
    }
    // #region 产品角色限制
    async getProductEnableRoleList(product_id) {
        return await this.productApi.getProductEnableRoleList(product_id);
    }
    async getProductResouce() {
        return await this.productApi.getProductResouce();
    }
    async getResourcesRoleLimitation(id) {
        return await this.productApi.getResourcesRoleLimitation(id);
    }
    async postProductRolesLimitation(params) {
        return await this.productApi.postProductRolesLimitation(params);
    }
    getResourcesProductResources(product_id) {
        return this.productApi.getResourcesProductResources(product_id);
    }
    getResourcesRoleResources(role_id) {
        return this.productApi.getResourcesRoleResources(role_id);
    }
};
ProductsService = __decorate([
    injectable(),
    __param(0, inject(Symbols.ProductApi)),
    __param(1, inject(Symbols.BoHttp)),
    __param(2, inject(Symbols.ProductApiUrls)),
    __param(3, inject(Symbols.ProductService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], ProductsService);
export { ProductsService };
